import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import "./Navbar.css";
import { useProduct } from "@/betby/hooks/useProduct";

const HomeNavbar = ({ onOpenStore }) => {
  const {
    user,
    currentMode,
    switchMode,
    getSCBalance,
    getGCBalance,
    setShowUserInfoModal,
    refreshWallet,
  } = useAuth();

  const [scBalance, setScBalance] = useState(0);
  const [gcBalance, setGcBalance] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Update balances when wallet changes
  useEffect(() => {
    setScBalance(getSCBalance());
    setGcBalance(getGCBalance());
  }, [getSCBalance, getGCBalance]);

  // Fetch wallet on mount and on mode change
  useEffect(() => {
    if (user) {
      refreshWallet();
    }
  }, [user, refreshWallet]);

  // Wallet refresh interval (10 minutes)
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(
      () => {
        refreshWallet();
      },
      10 * 60 * 1000,
    ); // 10 minutes

    return () => clearInterval(interval);
  }, [user, refreshWallet]);

  const handleLogoClick = () => {
    if (user) {
      setShowUserInfoModal(true);
    }
  };

  const currentBalance = currentMode === "gc" ? gcBalance : scBalance;
  const { isWinburst } = useProduct();
  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-left">
          <div
            className="logo"
            onClick={handleLogoClick}
            style={{ cursor: user ? "pointer" : "default" }}
          >
            <img
              src={isWinburst ? "/winburst-logo.png" : "/joit777-logo.png"}
              alt="WinBurst"
            />
            {!isMobile && <h1>{isWinburst ? "WinBurst" : "jolt777"}</h1>}
          </div>
        </div>

        <div className="nav-right">
          <div className="mode-toggle">
            <button
              style={{
                background:
                  currentMode === "gc"
                    ? isWinburst
                      ? "linear-gradient(135deg, #5eead4 0%, #3b82f6 100%)"
                      : "linear-gradient(135deg, #eeead4 0%, #eee2f6 100%)"
                    : "",
              }}
              className={`mode-btn ${currentMode === "gc" ? "active" : ""}`}
              onClick={() => switchMode("gc")}
            >
              <img src="/gc-icon.png" alt="GC" className="currency-icon" />
              {!isMobile && <span>GC</span>}
            </button>
            <button
              style={{
                background:
                  currentMode === "sc"
                    ? isWinburst
                      ? "linear-gradient(135deg, #5eead4 0%, #3b82f6 100%)"
                      : "linear-gradient(135deg, #eeead4 0%, #eee2f6 100%)"
                    : "",
              }}
              className={`mode-btn ${currentMode === "sc" ? "active" : ""}`}
              onClick={() => switchMode("sc")}
            >
              <img src="/sc-icon.png" alt="SC" className="currency-icon" />
              {!isMobile && <span>SC</span>}
            </button>
          </div>

          <div className="balance-section">
            <div className="balance-display">
              <span className="balance-amount">
                {currentBalance.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
              <span className="balance-currency">
                {currentMode.toUpperCase()}
              </span>
            </div>
            <button
              className="add-btn"
              onClick={onOpenStore}
              style={{
                background: isWinburst
                  ? "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)"
                  : "linear-gradient(135deg, #eeead4 0%, #eee2f6 100%)",
              }}
            >
              <i className="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HomeNavbar;
